import React from "react";
import { Field } from "formik";

import { FormSelect } from "../../../../../components/ui";
import * as constants from "../constants";
import { INewRithmicAccountData } from "../../../../../api/rithmic/index.types";
import { INewRithmicAccountFormData } from "../index";
import { ORIGINAL_ACCOUNT_TYPE } from "../constants";

interface IProps {
  setFieldValue: (field: string, value: unknown, shouldValidate?: boolean | undefined) => void;
  values: INewRithmicAccountData;
}

const AccountTypeSelect: React.FC<IProps> = ({ setFieldValue, values }) => {
  const onChangeAccountType = (
    event: React.ChangeEvent<{ value: string }>,
    setFieldValue: (field: string, value: unknown, shouldValidate?: boolean | undefined) => void,
    values: INewRithmicAccountFormData["formValues"]
  ) => {
    setFieldValue("account_type", event.target.value);
    const { original_account_type } = values;
    const isSelectedNAOption = original_account_type === "x";
    if (event.target.value.includes("TCP")) {
      if (isSelectedNAOption) setFieldValue("original_account_type", "");
    } else {
      if (!isSelectedNAOption) {
        const naOriginalAccount = ORIGINAL_ACCOUNT_TYPE[0].value;
        setFieldValue("original_account_type", naOriginalAccount);
      }
    }
  };

  return (
    <Field
      name="account_type"
      label="Account Type"
      placeholder="Plan"
      component={FormSelect}
      options={constants.EDX_ACCOUNT_TYPE_OPTIONS}
      onChange={(event: React.ChangeEvent<{ value: string }>) =>
        onChangeAccountType(event, setFieldValue, values)
      }
    />
  );
};

export default AccountTypeSelect;
